<template>
  <span style="position: relative;top: -3px;">
    <i 
      v-for="n in Math.floor(stars)"  
      :key="n" 
      class="fas fa-star mr-1 stars" 
      :title="stars + ' ' + (stars === 1 ? 'star' : 'stars')">
    </i>
  </span>
</template>

<script>
export default {
  props: ['stars']
};
</script>
